var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styleObject)},[_c('fixeau-head',{attrs:{"classification":_vm.classification,"values":_vm.values,"name":_vm.name}}),_c('router-link',{staticClass:"btn",attrs:{"to":{ name: 'infographic', query: {pinNumber: _vm.pinNumber}, params: {back_page: _vm.back_page} }}},[_vm._v(_vm._s(_vm.$t('devices.details')))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }